import React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { AlertTriangle, ArrowRight } from "lucide-react";

/**
 * One-time confirmation shown before a customer takes the (one-way) step of
 * becoming a Companion (provider). After this they can only act as a customer
 * again by subscribing to COMPANIN Dual.
 */
export default function BecomeProviderConfirm({ open, onOpenChange, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="become-provider-confirm">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
            <AlertTriangle className="h-6 w-6 text-amber-600" />
          </div>
          <DialogTitle className="text-center text-stone-900">
            Become a Companion?
          </DialogTitle>
          <DialogDescription className="text-center text-stone-600 leading-relaxed pt-1">
            Once you become a Companion (provider), you'll start earning by
            hosting bookings and hangouts. But you can <strong>no longer
            book companions yourself</strong> unless you subscribe to{" "}
            <strong>COMPANIN Dual</strong> (£9.99/month).
            <br />
            <br />
            This decision is one-way. Continue?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="rounded-full"
            data-testid="become-provider-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="rounded-full bg-[#4A5D4E] hover:bg-[#3B4A3E] text-white"
            data-testid="become-provider-confirm-btn"
          >
            Yes, become a Companion <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
